import { BlockType } from '../../types/index.js';
import { DynamicBlock as Component } from './Block.js';
export const RegisteredDynamicBlock = (_intl) => ({
    recommendedName: 'DynamicBlock',
    Component,
    config: {
        type: BlockType.Block,
        usable: false,
        defaultProps: {
            staffOnly: false,
        },
    },
});
//# sourceMappingURL=registered.js.map